import { timeLabel } from "../data/main";

export const ageToString = (values: Array<number>, t: any) =>
  values
    .map((e: number, index: number) =>
      e > 0 && timeLabel[index]
        ? e + t(`p.${timeLabel[index][e === 1 ? 1 : 0]}`)
        : ""
    )
    .filter((e: string) => e !== "")
    .join(", ");
